export const UUID_REGEX =
  /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/;

export const TCR_BRAND_ID_REGEX = /^[Bb][0-9a-zA-Z]{6}$/;

export const TCR_CAMPAIGN_ID_REGEX = /^[Cc][0-9a-zA-Z]{6}$/;
